import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { db } from '../../../config/firebase';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  makeStyles,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  Divider,
  TextField,
  Radio,
  RadioGroup,
  FormLabel,
  FormControl,
  FormControlLabel,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { Creators } from '../../../store/pmp/actions';
import { Formik } from 'formik';
import { NumericContainer, Spacing, TopSpacing, ButtonContainer} from './styles';

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(2)
  },
  formControl: {
    marginTop: 2,
    minWidth: 300,
  },
  modalEdit: {
    width: 900
  }
}));

const Results = ({ 
  className, Persons, userId, userRole, 
  page, setPage, limit, setLimit, arrayLength, ...rest }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openWhatsApp, setOpenWhatsApp] = useState(false);
  const [personToEdit, setPersonToEdit] = useState({});
  const [personToText, setPersonToText] = useState(undefined);
  const [idToDelete, setIdToDelete] = useState();
  const [roleToEdit, setRoleToEdit] = useState();
  const dispatch = useDispatch();

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleEdit = (person) => {
    setPersonToEdit(person);
    setOpen(true);
  };

  const handleDelete = (id, name) => {
    setIdToDelete(id);
    setOpenDelete(true);
  };

  const handleMessage = ({ message }) => {
    if (!personToText || !personToText.phone) return;

    const a = document.createElement('a');
    a.target = '_blank';
    a.href = `https://api.whatsapp.com/send?phone=55${personToText.phone}&text=${encodeURIComponent(message)}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setOpenWhatsApp(false);
  };

  const handleMessageDialog = (person) => {
    setPersonToText(person);
    setOpenWhatsApp(true);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenDelete(false);
    setOpenWhatsApp(false);
  };

  const handleEditUser = (values) => {
    console.log(values);
    const officeId = sessionStorage.getItem('office-id');
    const { name, email } = values
    const docRef = db.collection('gabinete').doc(officeId).collection('users').doc(personToEdit.id);
    let role = roleToEdit;
    docRef.set({
      name,
      email,
      role
    }, { merge: true }).then(() => {
      console.log('entrou no then');
      setOpen(false);
      const payload = { officeId };
      dispatch(Creators.getUsers(payload));
    });
  };

  const handleDeletePerson = () => {
    const officeId = sessionStorage.getItem('office-id');
    try {
      db.collection('gabinete').doc(officeId).collection('person').doc(idToDelete).delete().then(function() {
        setOpenDelete(false);
        const payload = { officeId };
        dispatch(Creators.getPersons(payload));
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleStatusChange = (event) => {
    console.log(event.target.value);
    setRoleToEdit(event.target.value);
  };

  useEffect(() => {
    console.log(personToEdit);
    if (personToEdit.role === 'normal') {
      setRoleToEdit('normal');
    }
    else if (personToEdit.role === 'manager') {
      setRoleToEdit('manager');
    }
    else {
      setRoleToEdit('admin');
    }
    
  }, [personToEdit]);

  const isAdmin = () => {
    if (userRole === 'admin') return false;
    else return true;
  }

  const canEdit = () => {
    if (userRole !== 'normal') return false;
    else return true;
  };

  const getUserRole = (role) => {
    switch (role) {
      case 'admin':
        return 'Administrador';
      case 'manager':
        return 'Gestor';
      case 'normal':
        return 'Colaborador';
      default: return '';
    }
  }

  return (
    <>
    {Persons &&
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <PerfectScrollbar>
        <Box minWidth={1200}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{fontWeight: 'bold', width: 220}}>
                  Nome
                </TableCell>
                <TableCell style={{fontWeight: 'bold', width: 270}}>
                  Email
                </TableCell>
                <TableCell style={{fontWeight: 'bold', width: 180}}>
                  Função
                </TableCell>
                <TableCell style={{fontWeight: 'bold', width: 120}}>
                  WhatsApp
                </TableCell>
                <TableCell style={{fontWeight: 'bold', width: 100}}>
                  Editar
                </TableCell>
                <TableCell style={{fontWeight: 'bold', width: 100}}>
                  Deletar
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Persons.map((Person) => (
                <TableRow
                  hover
                  key={Person.id}
                >
                  <TableCell>
                    <Box
                      alignItems="center"
                      display="flex"
                    >
                      <Typography
                        color="textPrimary"
                        variant="body1"
                      >
                        {Person.name}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    {Person.email === null ? ' - ' : Person.email}
                  </TableCell>
                  <TableCell>
                    {getUserRole(Person.role)}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      aria-label="whatsapp"
                      size="small"
                      onClick={() => handleMessageDialog(Person)}
                      disabled={!Person.phone}
                    >
                      <WhatsAppIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    <IconButton 
                      aria-label="expand row" 
                      disabled={canEdit()}
                      size="small" 
                      onClick={() => handleEdit(Person)} >
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    <IconButton 
                      aria-label="expand row" 
                      size="small" 
                      onClick={() => handleDelete(Person.id, Person.name)}
                      disabled={isAdmin()}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={arrayLength}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[5, 10, 25]}
        labelRowsPerPage="Linhas por página"
      />
      <Dialog
        open={openDelete}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box>
          <DialogTitle id="alert-dialog-title">{"Deseja excluir essa pessoa?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Essa ação será irreversível.
            </DialogContentText>
          </DialogContent>
          <ButtonContainer>
            <span>
              <Button 
                onClick={handleClose} 
                color="primary"
              >
                Cancelar
              </Button>
            </span>
            <span>
              <Button 
                onClick={handleDeletePerson} 
                color="secondary" 
                autoFocus
              >
                Deletar
              </Button>
            </span>
          </ButtonContainer>
        </Box>
      </Dialog>
      <Dialog
        open={openWhatsApp}
        fullWidth
        maxWidth={"md"}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <Box>
          <DialogContent>
            {personToText && (
              <Formik
                initialValues={{
                  message: '',
                }}
                onSubmit={(values) => {
                  handleMessage(values);
                }}
              >
                {({
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  values,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Box sm={3}>
                      <Typography
                        color="textPrimary"
                        variant="h2"
                      >
                        Enviar mensagem para {personToText.name}
                      </Typography>
                    </Box>
                    <TextField
                      label="Mensagem"
                      margin="normal"
                      name="message"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.message}
                      multiline
                      rows={8}
                      variant="outlined"
                      fullWidth
                    />
                    <ButtonContainer>
                      <span>
                        <Button
                          color="primary"
                          fullWidth
                          size="small"
                          variant="outlined"
                          onClick={() => setOpenWhatsApp(false)}
                        >
                          Voltar
                        </Button>
                      </span>
                      <span>
                        <Button
                          color="primary"
                          fullWidth
                          size="small"
                          type="submit"
                          variant="contained"
                        >
                          Enviar
                        </Button>
                      </span>
                    </ButtonContainer>
                  </form>
                )}
              </Formik>
            )}
          </DialogContent>
        </Box>
      </Dialog>
      <Dialog 
        open={open}
        fullWidth
        maxWidth={"md"}
        onClose={handleClose} 
        aria-labelledby="form-dialog-title">
        <Box >
          <DialogContent>
            <Formik
              initialValues={{
                name: personToEdit.name,
                email: personToEdit.email,
              }}
              validationSchema={
                Yup.object().shape({
                  name: Yup.string().max(255).required('Nome da pessoa é obrigatório'),
                  email: Yup.string(),
                })
              }
              onSubmit={(values) => {
                handleEditUser(values);
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                touched,
                values
              }) => (
                <form onSubmit={handleSubmit}>
                  <Box sm={3}>
                    <Typography
                      color="textPrimary"
                      variant="h2"
                    >
                      Editar cadastro de {personToEdit.name}
                    </Typography>
                  </Box>
                  <NumericContainer>
                    <TextField
                      error={Boolean(touched.name && errors.name)}
                      helperText={touched.name && errors.name}
                      label="Nome"
                      margin="normal"
                      name="name"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.name}
                      variant="outlined"
                      fullWidth
                    />
                    <Spacing />
                    <TextField
                      fullWidth
                      label="Email"
                      margin="normal"
                      name="email"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.email}
                      variant="outlined"
                      disabled
                    />
                  </NumericContainer>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Função do colaborador</FormLabel>
                    <RadioGroup aria-label="priority" name="priority" defaultValue="a">
                      <FormControlLabel 
                        value="normal"
                        control={
                          <Radio
                            checked={roleToEdit === 'normal'}
                            onChange={handleStatusChange}
                            value="normal"
                            color="primary"
                            name="radio-button-demo"
                            inputProps={{ 'aria-label': 'A' }}
                          />
                        }
                        label="Colaborador (Criação)"
                      />
                      <FormControlLabel 
                        value="manager"
                        control={
                          <Radio
                            checked={roleToEdit === 'manager'}
                            onChange={handleStatusChange}
                            value="manager"
                            name="radio-button-demo"
                            inputProps={{ 'aria-label': 'B' }}
                          />
                        }
                        label="Gestor (Criação e Edição)"
                      />
                      <FormControlLabel 
                        value="admin"
                        control={
                          <Radio
                            checked={roleToEdit === 'admin'}
                            onChange={handleStatusChange}
                            value="admin"
                            name="radio-button-demo"
                            color="primary"
                            inputProps={{ 'aria-label': 'C' }}
                          />
                        }
                        label="Administrador (Criação, Edição e Deleção)"
                      />
                    </RadioGroup>
                  </FormControl>
                    <Divider />
                  <TopSpacing />
                  <ButtonContainer>
                    <span>
                      <Button
                        color="primary"
                        fullWidth
                        size="small"
                        variant="outlined"
                        onClick={() => setOpen(false)}
                      >
                        Voltar
                      </Button>
                    </span>
                    <span>
                      <Button
                        color="primary"
                        fullWidth
                        size="small"
                        type="submit"
                        variant="contained"
                      >
                        Salvar
                      </Button>
                    </span>
                  </ButtonContainer>
                </form>
              )}
            </Formik>
          </DialogContent>
        </Box>
      </Dialog>
    </Card>
  }
  </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  Persons: PropTypes.array.isRequired
};

export default Results;
